"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCloudPortalApi = createCloudPortalApi;
const piral_core_1 = require("piral-core");
function createCloudPortalApi(user) {
    return (ctx) => {
        ctx.dispatch((state) => (Object.assign(Object.assign({}, state), { user, registry: Object.assign(Object.assign({}, state.registry), { trackers: {}, headerLinks: {} }) })));
        return (api) => ({
            getCurrentUser() {
                return ctx.readState(s => s.user);
            },
            registerTracker(name, component) {
                ctx.dispatch((state) => (Object.assign(Object.assign({}, state), { registry: Object.assign(Object.assign({}, state.registry), { trackers: (0, piral_core_1.withKey)(state.registry.trackers, name, (0, piral_core_1.withApi)(ctx, component, api, 'extension', 'tracker')) }) })));
            },
            unregisterTracker(name) {
                ctx.dispatch((state) => (Object.assign(Object.assign({}, state), { registry: Object.assign(Object.assign({}, state.registry), { trackers: (0, piral_core_1.withoutKey)(state.registry.trackers, name) }) })));
            },
            registerHeaderAction(name, settings) {
                ctx.dispatch((state) => (Object.assign(Object.assign({}, state), { registry: Object.assign(Object.assign({}, state.registry), { headerLinks: (0, piral_core_1.withKey)(state.registry.headerLinks, name, settings) }) })));
            },
            unregisterHeaderAction(name) {
                ctx.dispatch((state) => (Object.assign(Object.assign({}, state), { registry: Object.assign(Object.assign({}, state.registry), { headerLinks: (0, piral_core_1.withoutKey)(state.registry.headerLinks, name) }) })));
            },
        });
    };
}
